import React, { useEffect, useState } from 'react';
import { Form, Col, Row, Card, Tag, notification, Modal } from 'antd';
import { FormInstance } from 'antd/lib/form';
import Title from 'antd/lib/typography/Title';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { deleteThirdPartyBkAccount } from 'services/thirdParty';
import BankAccountModal from './BankAccountModal';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import { useForm } from 'antd/lib/form/Form';
import address from 'components/address';
import ModalSFS from 'components/theme_components/ModalSFS';
import AddresseModal from '../Addresse/AddresseModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Notifications from 'components/theme_components/Notifications';
import { refresh } from 'less';

export type BankCardProps = {
  record: any;
  action?: string;
  onDelete: () => void;
  onSave: (updatedAccount: any, action: string) => void;
  refetch: any;
  onDone: () => void;
  deleteDisabled?: boolean; // Add this new prop
};

const BankCard = ({ 
  record, 
  onDelete, 
  onSave, 
  action, 
  refetch, 
  onDone, 
  deleteDisabled = false // Default to false
}: BankCardProps) => {
  const colors: { [key: string]: string }[] = [
    { VN: '#C8CFF0' },
    { VO: '#E5E7EF' },
    { VD: '#D6E9E6' },
    { PR: '#FEEFE9' },
  ];
  const [form] = useForm();
  
  const handleDelete = () => {
    // Check if deletion is disabled first
    if (deleteDisabled) {
      Modal.warning({
        title: 'Action non autorisée',
        content: 'Vous ne pouvez pas supprimer le dernier compte bancaire. Au moins un compte bancaire est requis.',
      });
      return;
    }

    if (record.bkstatus === 'VALID') {
      Modal.confirm({
        title: 'Confirmation',
        content: 'Your deletion request has been taken into account',

        onOk: () => {
          deleteThirdPartyBkAccount({
            tpbkid: record.tpbkid,
            tpid: record.tpid,
          }).then((res) => {
            Notifications({
              status: "success",
              message: "Delete ThirdParty Account",
              description: "Delete ThirdParty Account",
              duration: 10,
              placement: 'topRight',
            });
            onDelete();
          });
        },
      });
    } else {
      Modal.error({
        content: "You don't have the authority to delete",
      });
    }
  };

  return (
    <Form form={form} className="mb-4">
      <Row gutter={[16, 16]} justify="center" className="ml-0 mr-0">
        <Col span={22}>
          <Card className="activity-card">
            <Row gutter={[16, 16]} className="ml-0 mr-0">
              <Col span={23}>
                <Title level={4} className="d-flex align-center">
                  {record.bkcodename ?? 'default'}
                </Title>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="ml-0 mr-0">
              <Col span={23}>
                <Title level={2} className="d-flex align-center">
                  {record?.tpbankname}
                  {record?.tpBankAccountProductList
                    ?.sort((a: any, b: any) => a.priority - b.priority)
                    ?.map(
                      (
                        product: { prcode: string; priority: number },
                        index: number
                      ) => {
                        const color = colors.find((c) => c[product.prcode])?.[
                          product.prcode
                        ];

                        return (
                          <Tag
                            key={index}
                            color={color}
                            className="tag-status tag-status-default ml-2 p-2"
                            bordered={false}
                          >
                            <Tag
                              bordered
                              color={color}
                              style={{ width: 24, height: 24 }}
                              className="tag-status-nbr m-1 p-1"
                            >
                              {product?.priority}
                            </Tag>
                            {product.prcode}
                          </Tag>
                        );
                      }
                    )}
                  <ModalSFS
                    trigger={({ setVisible }) => (
                      <EditOutlined
                        className="gray-color font-size-25 floatRight"
                        onClick={() => setVisible(true)}
                      />
                    )}
                    title="updatebkaccount"
                  >
                    <BankAccountModal
                      form={form}
                      record={record}
                      action="edit"
                      setVisible={() => false}
                      tpid={record.tpid}
                      refetch={() => refetch()}
                    />
                  </ModalSFS>
                </Title>
              </Col>

              <Col span={1}>
                <DeleteOutlined
                  className={`font-size-25 ${deleteDisabled ? 'color-gray cursor-not-allowed' : 'color-red cursor-pointer'}`}
                  onClick={handleDelete}
                  style={{ 
                    opacity: deleteDisabled ? 0.5 : 1,
                    cursor: deleteDisabled ? 'not-allowed' : 'pointer'
                  }}
                />
              </Col>

              <Col span={9}>
                <p className="font-size-18 gray-color">
                  <GetLabel label="bkholder" />
                </p>
                <p className="font-size-20">{record.bkholder}</p>
              </Col>

              <Col span={9}>
                <p className="font-size-18 gray-color">
                  <GetLabel label="tpiban" />
                </p>
                <p className="font-size-20">{record.tpiban}</p>
              </Col>

              <Col span={6}>
                <p className="font-size-18 gray-color">
                  <GetLabel label="tpbic" />
                </p>
                <p className="font-size-20">{record.tpbic}</p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};

export default BankCard;